import 'jquery';

import '@angular/core';
import '@angular/common';
import '@angular/platform-browser';
import '@angular/platform-browser-dynamic';
import '@angular/router-deprecated';
import 'rxjs/Rx';

import 'bootstrap-sass';


/** WEBPACK FOOTER **
 ** ./app/vendor.ts
 **/